const testimonials = [
  {
    name: "Margaret T.",
    location: "Sarasota, FL",
    rating: 5,
    text: "My daughter is studying art history in Florence through Ringling College's abroad program. Two weeks before her departure, we realized her passport had expired — and the program deadline was absolute. I called Fast Passport Center in a panic. They walked us through the exact documents needed, reviewed everything before submission, and her passport arrived with four days to spare. The service was as professional as any gallery opening I have attended in this town.",
    service: "Student Passport Renewal",
  },
  {
    name: "Robert K.",
    location: "Siesta Key, FL",
    rating: 5,
    text: "I am a retired museum curator and planned a Caribbean cruise out of Tampa with my wife for our 40th anniversary. We booked during a flash sale 45 days out and discovered my passport was damaged from a beach trip last year. Fast Passport Center handled the replacement with expedited processing, and we boarded the ship with time to spare. Their attention to detail matched the standards I expected from decades in the arts world.",
    service: "Damaged Passport Replacement",
  },
  {
    name: "Diana L.",
    location: "Longboat Key, FL",
    rating: 5,
    text: "I am a board member at the Sarasota Opera and was invited to a private donor trip to Vienna for a Wagner festival. The invitation came three weeks before departure — and my passport had less than three months validity, which Austria would not accept. Fast Passport Center processed my renewal in under a week, and I attended every performance. I have recommended them to half the board since.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SarasotaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Sarasota &amp; Cultural Coast Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Sarasota, Siesta Key, and Longboat Key travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}